import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ImprintComponent {
  translate = inject(TranslateService);
  private activatedRoute = inject(ActivatedRoute);

  // selected language (de)
  lang: string = this.activatedRoute.snapshot.params.language_id;

  collected_parts: string[] = [];

  public trigger = 0;

  constructor() {
    const translate = this.translate;

    translate.use(this.lang);

    translate.get(translate.getCurrentLang()).subscribe((translation) => {
      Object.keys(translation).forEach((key) => {
        if (!key.startsWith('imprint.content.')) {
          return;
        }

        this.collected_parts.push(key);
      });

      this.trigger++;
    });
  }

  goBack(): void {
    history.back();
  }
}
